import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { alpha } from "@mui/material/styles";
import { LoadingButton } from "@mui/lab";
import { Box, Divider, Typography, Stack, MenuItem } from "@mui/material";
import { PATH_DASHBOARD, PATH_AUTH } from "routes/paths";
import { CustomAvatar } from "components/custom-avatar";
import { useSnackbar } from "components/snackbar";
import MenuPopover from "components/menu-popover";
import { IconButtonAnimate } from "components/animate";
import { useDispatch, useSelector } from "react-redux";
import { emptyMenu } from "redux/slices/permission/permission.slice";
import ConfirmDialog from "components/confirm-dialog/ConfirmDialog";
import { capitalize } from "lodash";

export default function AccountPopover() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userinfo } = useSelector((state) => state.userinfo);
  const { enqueueSnackbar } = useSnackbar();

  const [openPopover, setOpenPopover] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const token = JSON.parse(localStorage.getItem("auth"))?.token;

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleLogout = async () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      dispatch(emptyMenu());
      navigate(PATH_AUTH.login, { replace: true });
      handleClosePopover();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Unable to logout!", { variant: "error" });
    }
  };

  const handleClickItem = (path) => {
    handleClosePopover();
    navigate(path);
  };
  useEffect(() => {
    if (!token) handleLogout();
  }, [token]);

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          ...(openPopover && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8)
            }
          })
        }}
      >
        <CustomAvatar
          src={userinfo?.user?.avatar}
          alt={capitalize(userinfo?.user?.firstName)}
          name={capitalize(userinfo?.user?.firstName)}
        />
      </IconButtonAnimate>

      <MenuPopover
        open={openPopover}
        onClose={handleClosePopover}
        sx={{ width: 200, p: 0 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {`${capitalize(userinfo?.user?.firstName)} ${capitalize(
              userinfo?.user?.lastName
            )}${
              userinfo?.user?.role?.name
                ? `(${capitalize(userinfo.user.role.name)})`
                : ""
            }`}
          </Typography>

          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {userinfo?.user?.email}
          </Typography>
        </Box>
        <Divider sx={{ borderStyle: "dashed" }} />
        <Divider sx={{ borderStyle: "dashed" }} />
        <MenuItem
          onClick={() => {
            handleClosePopover();
            setOpenConfirm(true);
          }}
          sx={{ m: 1 }}
        >
          Logout
        </MenuItem>
      </MenuPopover>
      <ConfirmDialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        title="Logout"
        content="Are you sure want to Logout?"
        action={
          <LoadingButton
            variant="contained"
            color="error"
            onClick={handleLogout}
            sx={{ m: 1 }}
          >
            Yes
          </LoadingButton>
        }
      />
    </>
  );
}
